export enum UiControlType {
    Text,
    Date,
    YesNo,
    Dropdown,
    Lookup,
    Number,
    Decimal,
    Currency
}